import { AccountMinusOutlineIcon } from './AccountMinusOutlineIcon';

/**
 * author: Peter Noble
 * id C03476FC-2655-4137-862E-28D714E93A50
 * name account-minus-outline
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-minus-outline.svg
 * tags
 * - Account / User 
 */
export const PersonMinusOutlineIcon = AccountMinusOutlineIcon;
export default PersonMinusOutlineIcon